import React, {ChangeEvent, useRef, useState} from 'react';

export interface InterfaceAccountEnterprise {
    companyName: string;
    companySiret: string;
    companyLocation: string;
    declarationLocation: string;
    tjm: number;
    logo: string;
    vl: boolean;
    tvaNumber: string;
}

export type AccountEnterpriseProps = {
    handlerChange: (dataUser: InterfaceAccountEnterprise) => void;
    data: InterfaceAccountEnterprise;
    fieldErrors?: Record<string, string>;
}

const FormAccountEnterprise: React.FC<AccountEnterpriseProps> = ({handlerChange, data, fieldErrors = {}}) => {

    const [dataEnterprise, setDataEnterprise] = useState<InterfaceAccountEnterprise>(data);
    const [logoFileName, setLogoFileName] = useState<string>("");
    const inputRef = useRef<HTMLInputElement>(null);

    const eventChange = (key: keyof InterfaceAccountEnterprise, value: string | number | boolean) => {
        const v: InterfaceAccountEnterprise = {...dataEnterprise, [key]: value};
        setDataEnterprise(v);
        handlerChange(v);
    };

    const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.files) {
            const file: File = e.target.files[0];
            setLogoFileName(file.name);
            file.text().then((result) => eventChange("logo", result));
        }
    };

    return (
        <>
            <div className="configRow">
                <div className={`configField${fieldErrors.companyName ? " configField--error" : ""}`}>
                    <label htmlFor="companyName">Nom de l'entreprise</label>
                    <input id="companyName" type="text" value={dataEnterprise.companyName}
                           placeholder="Ma Société SAS"
                           onChange={(e) => eventChange("companyName", e.target.value)}/>
                    {fieldErrors.companyName && <span className="fcaFieldError">{fieldErrors.companyName}</span>}
                </div>
                <div className={`configField${fieldErrors.companySiret ? " configField--error" : ""}`}>
                    <label htmlFor="companySiret">N° SIRET</label>
                    <input id="companySiret" type="text" value={dataEnterprise.companySiret}
                           placeholder="14 chiffres"
                           onChange={(e) => eventChange("companySiret", e.target.value)}/>
                    {fieldErrors.companySiret && <span className="fcaFieldError">{fieldErrors.companySiret}</span>}
                </div>
            </div>

            <div className="configField">
                <label htmlFor="tva">N° TVA Intracommunautaire</label>
                <input id="tva" type="text" value={dataEnterprise.tvaNumber}
                       placeholder="FR12 345678901"
                       onChange={(e) => eventChange("tvaNumber", e.target.value)}/>
            </div>

            <div className="configField">
                <label htmlFor="companyLocation">Adresse de l'entreprise</label>
                <input id="companyLocation" type="text" value={dataEnterprise.companyLocation}
                       placeholder="12 rue de la Paix, 75002 Paris"
                       onChange={(e) => eventChange("companyLocation", e.target.value)}/>
            </div>

            <div className="configRow">
                <div className="configField">
                    <label htmlFor="declarationLocation">Ville pour les déclarations</label>
                    <input id="declarationLocation" type="text" value={dataEnterprise.declarationLocation}
                           placeholder="Paris"
                           onChange={(e) => eventChange("declarationLocation", e.target.value)}/>
                </div>
                <div className="configField">
                    <label htmlFor="tjm">TJM par défaut (€)</label>
                    <input id="tjm" type="number" min={0} max={9999} value={dataEnterprise.tjm}
                           onChange={(e) => eventChange("tjm", parseFloat(e.target.value))}/>
                </div>
            </div>

            <div className="configCheckRow">
                <input id="vl" type="checkbox" checked={dataEnterprise.vl}
                       onChange={(e) => eventChange("vl", e.target.checked)}/>
                <label htmlFor="vl">Versement libératoire</label>
            </div>

            <div className="configField">
                <label>Logo de l'entreprise</label>
                <div className="fcaDropZone" onClick={() => inputRef.current?.click()}>
                    <span className="material-symbols-outlined">upload_file</span>
                    <div className="fcaDropZoneTitle">
                        {logoFileName ? "Fichier sélectionné" : "Choisir un logo"}
                    </div>
                    <div className="fcaDropZoneHint">Format accepté : SVG (max 5 Mo)</div>
                    {logoFileName && <div className="fcaDropZoneFileName">{logoFileName}</div>}
                    <input ref={inputRef} id="fileInput" type="file" accept=".svg"
                           style={{display: "none"}} onChange={handleFileChange}/>
                </div>
                {dataEnterprise.logo && (
                    <div className="configLogoPreview">
                        <img src={'data:image/svg+xml;base64,' + Buffer.from(dataEnterprise.logo).toString("base64")}
                             alt="logo entreprise" height={48}/>
                    </div>
                )}
            </div>
        </>
    );
};

export default FormAccountEnterprise;
